// src/components/TaskDialog.tsx
import React from "react";
import { Task } from "../types/task"; // Assuming Task is imported from task.d.ts
import TaskForm from "./TaskForm"; // The actual form component

interface TaskDialogProps {
  isOpen: boolean; // Controls dialog visibility
  onClose: () => void; // Function to close the dialog
  initialTask?: Omit<Task, "id" | "createdAt" | "updatedAt" | "userId"> | null;
  onSubmit: (
    task: Omit<Task, "id" | "createdAt" | "updatedAt" | "userId">
  ) => void;
}

const TaskDialog: React.FC<TaskDialogProps> = ({
  isOpen,
  onClose,
  initialTask,
  onSubmit,
}) => {
  if (!isOpen) return null; // Don't render anything if not open

  return (
    // Modal Overlay
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)", // Dark overlay
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1000, // Ensure it's on top of other content
      }}
      onClick={onClose} // Close if clicking outside the form
    >
      {/* Modal Content */}
      <div
        style={{
          backgroundColor: "white",
          padding: "20px",
          borderRadius: "8px",
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
          position: "relative",
          minWidth: "400px", // Adjust as needed
          maxWidth: "80%",
          maxHeight: "90%",
          overflowY: "auto",
        }}
        onClick={(e) => e.stopPropagation()} // Prevent click from closing dialog
      >
        {/* Close Button */}
        <button
          onClick={onClose}
          style={{
            position: "absolute",
            top: "10px",
            right: "10px",
            background: "none",
            border: "none",
            fontSize: "1.5rem",
            cursor: "pointer",
            color: "#333",
          }}
        >
          &times; {/* HTML entity for multiplication sign / close button */}
        </button>

        {/* Task Form */}
        <TaskForm
          initialTask={initialTask}
          onSubmit={(taskData) => {
            onSubmit(taskData); // Call parent's onSubmit
            onClose(); // Close dialog after submission
          }}
          submitButtonText={initialTask ? "Update Task" : "Add Task"}
          // No separate onCancel prop for TaskForm needed here, as the dialog's onClose handles it
        />
      </div>
    </div>
  );
};

export default TaskDialog;
